import Vue from 'vue';
import moment from 'moment'

Vue.filter('capitalize', data => {
  let capitalized = [];
  if(data){
    data.split(" ").forEach((word) => {
      capitalized.push(
        word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
      );
    });
    return capitalized.join(" ");
  }
});

Vue.filter('formattedDate', data => {
  return moment(data).format('DD.MM.YYYY')
});
